import React, {PureComponent} from 'react';
import {Input, List, Radio} from 'antd';
import IconSearch from "../../../../iconfont/search";
import {ImText, ImAudio, ImCard, ImFile, ImImage, ImRecord, ImRed, ImVideo, ImWxApp, ImVideoHao} from "./msgType";
import CloudApi from "../../../cloud/cloud_api";
import imLoading from "../../iconfont/loading/imLoading.gif";

const obj = {avatar: 'testImg', name: '张麻子', time: 2020}

let timer = null
let timer2 = null

class ChatRecord extends PureComponent {
    state = {
        msgType: '9',
        inputting: false,
        keyword: '',
        pageNum: 1,
        pages: 2,
        loading: true,

        height: 0,

        list: [],
    }

    componentDidMount() {
        this.getRecordList()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {chat_wxid, wxid} = this.props
        if (chat_wxid != nextProps.chat_wxid || wxid != nextProps.wxid) {
            this.setState({
                msgType: '9',
                inputting: false,
                keyword: '',
                pageNum: 1,
                pages: 2,
                loading: true,
                list: [],
            }, () => {
                this.getRecordList(nextProps)
            })
        }
    }

    componentWillUnmount() {
        clearTimeout(timer)
        clearTimeout(timer2)
    }

    //滚动到底部部继续加载
    handleScroll = () => {
        clearTimeout(timer)
        const {pageNum, pages} = this.state
        let scroll = document.getElementById('im-record-words');
        let clientHeight = scroll.clientHeight  // 可视区域
        let scrollTop = scroll.scrollTop  //当前位置 最上面0
        let scrollHeight = scroll.scrollHeight //总高
        // console.log('777scrollTop', clientHeight, scrollHeight, scrollTop)

        // return
        //滚到顶部 继续加载, 此处防抖处理，高频触发，一定周期内仅执行一次
        if (scroll.scrollTop < 30 && pageNum < pages && clientHeight != scrollHeight) {
            //在元素塞进去之前  获取 height =  元素.scrollHeight - 元素.scrollTop  就是获取与底部的距离
            timer = setTimeout(() => {
                let height = scrollHeight - scrollTop //与底部的距离
                this.setState({
                    height: height,
                    pageNum: pageNum + 1,
                }, () => {
                    this.getRecordList()
                })
            }, 500)
        }

    }

    getRecordList = (nextProps) => {
        this.setState({loading: true})
        const {chat_wxid, wxid} = this.props
        const {keyword, msgType, pageNum, list, height} = this.state
        let queryParam = {
            pageNum: pageNum,
            pageSize: 20,
        }
        let bodyData = {
            keyword: keyword,
            chatWxId: nextProps ? nextProps.chat_wxid : chat_wxid,
            accountId: nextProps ? nextProps.wxid : wxid,
            msgType: msgType,  //9全部，1文件，2图片/视频
        }
        CloudApi.getChatRecordList(queryParam, bodyData, data => {
            this.setState({
                list: [...data.list.reverse(), ...list],
                loading: false,
                pages: data.pagInfo.pages
            }, () => {
                //仅请求第一页的时候， 滚动条 置底
                if (pageNum == 1) {
                    setTimeout(() => this.updateScroll())
                } else {
                    //在元素塞进去之后   元素.scrollTop = 元素.scrollHeight -  height (刚刚获取到的距离)
                    let scroll = document.getElementById('im-record-words');
                    scroll.scrollTop = scroll.scrollHeight - height
                }
            })
        }, error => {
            this.setState({loading: true})
        })
    }

    getNextRecordList = () => {
        const {pageNum} = this.state
        let scroll = document.getElementById('im-record-words');
        let clientHeight = scroll.clientHeight  // 可视区域
        let scrollTop = scroll.scrollTop  //当前位置 最上面0
        let scrollHeight = scroll.scrollHeight //总高

        //在元素塞进去之前  获取 height =  元素.scrollHeight - 元素.scrollTop  就是获取与底部的距离
        let height = scrollHeight - scrollTop //与底部的距离
        this.setState({
            height: height,
            pageNum: pageNum + 1,
        }, () => {
            this.getRecordList()
        })
    }

    //更新滚动条
    updateScroll = (time) => {
        let oWords = document.getElementById('im-record-words');
        if (oWords) {
            setTimeout(() => {
                oWords.scrollTop = oWords.scrollHeight
            }, time || 0)
        }
    }

    getSearchList = () => {
        this.setState({loading: true})
        const {chat_wxid, wxid} = this.props
        const {keyword, msgType, pageNum} = this.state
        let queryParam = {
            pageNum: pageNum,
            pageSize: 20,
        }
        let bodyData = {
            keyword: keyword,
            chatWxId: chat_wxid,
            accountId: wxid,
            msgType: msgType,  //9全部，1文件，2图片/视频
        }
        CloudApi.getChatRecordList(queryParam, bodyData, data => {
            this.setState({
                loading: false,
                list: data.list,
                pages: data.pagInfo.pages
            }, () => {
                //仅请求第一页的时候， 滚动条 置底
                if (pageNum == 1) {
                    setTimeout(() => this.updateScroll())
                } else {
                    //在元素塞进去之后   元素.scrollTop = 元素.scrollHeight -  height (刚刚获取到的距离)
                    let scroll = document.getElementById('im-record-words');
                    scroll.scrollTop = scroll.scrollHeight - height
                }
            })
        }, error => {
            this.setState({loading: true})
        })
    }

    onChange = (e, type) => {
        let value = e.target.value
        this.setState({
            [type]: value,
            pageNum: 1,
            list: []
        }, () => {
            this.getSearchList()
        })
    }

    inputChange = e => {
        clearTimeout(timer2)
        let value = e.target.value
        //9全部，1文件，2图片/视频
        if (this.state.msgType != 9) {
            this.setState({
                keyword: value,
            })
            return
        } else {
            this.setState({
                keyword: value,
                pageNum: 1,
                list: [],
                loading: true
            }, () => {
                //value变化 请求接口
                timer2 = setTimeout(() => {
                    this.getSearchList()
                }, 500)
            })
        }
    }

    onFocus = () => {
        this.setState({
            inputting: true
        })
    }

    onBlur = () => {
        this.setState({
            inputting: false
        })
    }

    render() {
        const {msgType, inputting, keyword, list, loading, pageNum, pages} = this.state
        const {wxid} = this.props
        return (
            <div className={'chat-record-max'}>
                <div className={'chat-record-header'} ref={r => this.headerRef = r}>
                    <Radio.Group value={msgType} buttonStyle="solid"
                                 className={'zk-chat-type'}
                                 onChange={e => this.onChange(e, 'msgType')}
                    >
                        {/*//9全部，1文件，2图片/视频*/}
                        <Radio.Button value="9">全部</Radio.Button>
                        <Radio.Button value="1">文件</Radio.Button>
                        <Radio.Button value="2">图片/视频</Radio.Button>
                    </Radio.Group>

                    <Input
                        className={inputting ? 'im-white-s1' : 'im-gray-s1'}
                        placeholder="搜索"
                        value={keyword}
                        onChange={this.inputChange}
                        prefix={<IconSearch/>}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                    />
                </div>

                {/* 消息记录列表*/}
                {/*     * 2文本 4聊天记录  6位置 14图片 23视频 15文件 13链接 41名片 26红包 29GIF 16语音 78小程序   10001撤回消息*/}
                <List
                    className={'chat-record-content'}
                    loading={pageNum == 1 && loading ? true : false}
                    itemLayout="horizontal"
                    // loadMore={loadMore}
                    id={'im-record-words'}
                    // onScroll={this.handleScroll}
                    dataSource={list}
                    renderItem={(item, index) => (
                        <List.Item key={item.content.msg_unique_identifier + item.content.timestamp}>
                            {
                                index == 0 && pageNum < pages && !loading ?
                                    <div className={'record-msg-loading'}>
                                        {
                                            <div onClick={this.getNextRecordList}
                                                 className={'record-msg-loading-more'}>查看更多消息
                                            </div>
                                        }
                                    </div> : ''
                            }
                            {
                                index == 0 && loading ?
                                    <div className={'record-msg-loading'}>
                                        <img src={imLoading}/>
                                    </div> : ''
                            }
                            {
                                index == 0 && !loading && pageNum > 1 && pageNum == pages ?
                                    <div className={'record-msg-loading'}>没有更多了</div> : ''
                            }
                            {
                                item.type == 2 || item.type == 0 ?
                                    <ImText data={item} keyword={keyword}/> :
                                    item.type == 23 || item.type == 103 ?
                                        <ImVideo data={item} wxid={wxid}/> :
                                        item.type == 14 || item.type == 101 || item.type == 29 ?
                                            <ImImage data={item} wxid={wxid}/> :
                                            item.type == 15 || item.type == 102 ?
                                                <ImFile data={item} wxid={wxid}/> :
                                                item.type == 41 ?
                                                    <ImCard data={item}/> :
                                                    item.type == 78 ?
                                                        <ImWxApp data={item}/> :
                                                        item.type == 26 ?
                                                            <ImRed data={item}/> :
                                                            item.type == 4 ?
                                                                <ImRecord data={item}/> :
                                                                item.type == 16 ?
                                                                    <ImAudio data={item} wxid={wxid}/> :
                                                                    item.type == 141 ?
                                                                        <ImVideoHao data={item}/> : ''
                            }
                        </List.Item>
                    )}
                />
            </div>
        );
    }
}

export default ChatRecord;